import { c as _c } from "react/compiler-runtime";
import { selectedCompanyContextSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { hasUserValidRoleCompanyLevel } from "@utils/access-control/company/company-access-control";
import { RequiredRoleCompanyLevelName } from "@utils/access-control/company/company-access-control-types";
/** Checks whether a user has permission for an action on company level or not */
export function useHasUserValidRoleCompanyLevel(t0) {
  const $ = _c(94);
  const {
    memberId
  } = t0 === undefined ? {} : t0;
  const currentUser = useAppSelector(currentUserSelector);
  const companyContext = useAppSelector(selectedCompanyContextSelector);
  const canViewCompanyMemberProfile = hasUserValidRoleCompanyLevel({
    currentUser,
    roleName: RequiredRoleCompanyLevelName.canViewCompanyMemberProfile,
    memberId,
    companyContext
  });
  let t1;
  if ($[0] !== companyContext || $[1] !== currentUser) {
    t1 = hasUserValidRoleCompanyLevel({
      roleName: RequiredRoleCompanyLevelName.canInviteUsersToCompany,
      currentUser,
      companyContext
    });
    $[0] = companyContext;
    $[1] = currentUser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canInviteUsersToCompany = t1;
  let t2;
  if ($[3] !== companyContext || $[4] !== currentUser) {
    t2 = hasUserValidRoleCompanyLevel({
      roleName: RequiredRoleCompanyLevelName.canResendInvitationToCompany,
      currentUser,
      companyContext
    });
    $[3] = companyContext;
    $[4] = currentUser;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const canResendInvitationToCompany = t2;
  let t3;
  if ($[6] !== companyContext || $[7] !== currentUser) {
    t3 = hasUserValidRoleCompanyLevel({
      roleName: RequiredRoleCompanyLevelName.canEditMember,
      currentUser,
      companyContext
    });
    $[6] = companyContext;
    $[7] = currentUser;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const canEditMember = t3;
  let t4;
  if ($[9] !== companyContext || $[10] !== currentUser) {
    t4 = hasUserValidRoleCompanyLevel({
      roleName: RequiredRoleCompanyLevelName.canDeleteMemberFromCompany,
      currentUser,
      companyContext
    });
    $[9] = companyContext;
    $[10] = currentUser;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const canDeleteMemberFromCompany = t4;
  let t5;
  if ($[12] !== companyContext || $[13] !== currentUser) {
    t5 = hasUserValidRoleCompanyLevel({
      roleName: RequiredRoleCompanyLevelName.canCreateGroups,
      currentUser,
      companyContext
    });
    $[12] = companyContext;
    $[13] = currentUser;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const canCreateGroups = t5;
  let t6;
  if ($[15] !== companyContext || $[16] !== currentUser) {
    t6 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canEditDefaultPlatform,
      companyContext
    });
    $[15] = companyContext;
    $[16] = currentUser;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const canEditDefaultPlatform = t6;
  let t7;
  if ($[18] !== companyContext || $[19] !== currentUser) {
    t7 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canFetchTeams,
      companyContext
    });
    $[18] = companyContext;
    $[19] = currentUser;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const canFetchTeams = t7;
  let t8;
  if ($[21] !== companyContext || $[22] !== currentUser) {
    t8 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canViewTeams,
      companyContext
    });
    $[21] = companyContext;
    $[22] = currentUser;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const canViewTeams = t8;
  let t9;
  if ($[24] !== companyContext || $[25] !== currentUser) {
    t9 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canCreateNewTeam,
      companyContext
    });
    $[24] = companyContext;
    $[25] = currentUser;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const canCreateNewTeam = t9;
  let t10;
  if ($[27] !== companyContext || $[28] !== currentUser) {
    t10 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canDeleteMembersFromTeam,
      companyContext
    });
    $[27] = companyContext;
    $[28] = currentUser;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const canDeleteMembersFromTeam = t10;
  let t11;
  if ($[30] !== companyContext || $[31] !== currentUser) {
    t11 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canEditTeams,
      companyContext
    });
    $[30] = companyContext;
    $[31] = currentUser;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const canEditTeams = t11;
  let t12;
  if ($[33] !== companyContext || $[34] !== currentUser) {
    t12 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canDeleteTeams,
      companyContext
    });
    $[33] = companyContext;
    $[34] = currentUser;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const canDeleteTeams = t12;
  let t13;
  if ($[36] !== companyContext || $[37] !== currentUser) {
    t13 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canInviteMembersToTeam,
      companyContext
    });
    $[36] = companyContext;
    $[37] = currentUser;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const canInviteMembersToTeam = t13;
  let t14;
  if ($[39] !== companyContext || $[40] !== currentUser) {
    t14 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canRemoveMemberFromProject,
      companyContext
    });
    $[39] = companyContext;
    $[40] = currentUser;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  const canRemoveMemberFromProject = t14;
  let t15;
  if ($[42] !== companyContext || $[43] !== currentUser) {
    t15 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canChangeMemberProjectRole,
      companyContext
    });
    $[42] = companyContext;
    $[43] = currentUser;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const canChangeMemberProjectRole = t15;
  let t16;
  if ($[45] !== companyContext || $[46] !== currentUser) {
    t16 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canViewSubscriptionDetails,
      companyContext
    });
    $[45] = companyContext;
    $[46] = currentUser;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  const canViewSubscriptionDetails = t16;
  let t17;
  if ($[48] !== companyContext || $[49] !== currentUser) {
    t17 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canViewProductDetails,
      companyContext
    });
    $[48] = companyContext;
    $[49] = currentUser;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  const canViewProductDetails = t17;
  let t18;
  if ($[51] !== companyContext || $[52] !== currentUser) {
    t18 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canExportWorkspace,
      companyContext
    });
    $[51] = companyContext;
    $[52] = currentUser;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  const canExportWorkspace = t18;
  let t19;
  if ($[54] !== companyContext || $[55] !== currentUser) {
    t19 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canEditAllCompanyProjects,
      companyContext
    });
    $[54] = companyContext;
    $[55] = currentUser;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  const canEditAllCompanyProjects = t19;
  let t20;
  if ($[57] !== companyContext || $[58] !== currentUser) {
    t20 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canManageSceneLicenses,
      companyContext
    });
    $[57] = companyContext;
    $[58] = currentUser;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  const canManageSceneLicenses = t20;
  let t21;
  if ($[60] !== companyContext || $[61] !== currentUser) {
    t21 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canManageXgSeats,
      companyContext
    });
    $[60] = companyContext;
    $[61] = currentUser;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  const canManageXgSeats = t21;
  let t22;
  if ($[63] !== companyContext || $[64] !== currentUser) {
    t22 = hasUserValidRoleCompanyLevel({
      currentUser,
      roleName: RequiredRoleCompanyLevelName.canViewMemberSeats,
      companyContext
    });
    $[63] = companyContext;
    $[64] = currentUser;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  const canViewMemberSeats = t22;
  let t23;
  if ($[66] !== companyContext || $[67] !== currentUser) {
    t23 = function hasUserPermissionCompanyLevel(t24) {
      const {
        roleName,
        memberId: memberId_0
      } = t24;
      return hasUserValidRoleCompanyLevel({
        roleName,
        currentUser,
        memberId: memberId_0,
        companyContext
      });
    };
    $[66] = companyContext;
    $[67] = currentUser;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  const hasUserPermissionCompanyLevel = t23;
  let t24;
  if ($[69] !== canChangeMemberProjectRole || $[70] !== canCreateGroups || $[71] !== canCreateNewTeam || $[72] !== canDeleteMemberFromCompany || $[73] !== canDeleteMembersFromTeam || $[74] !== canDeleteTeams || $[75] !== canEditAllCompanyProjects || $[76] !== canEditDefaultPlatform || $[77] !== canEditMember || $[78] !== canEditTeams || $[79] !== canExportWorkspace || $[80] !== canFetchTeams || $[81] !== canInviteMembersToTeam || $[82] !== canInviteUsersToCompany || $[83] !== canManageSceneLicenses || $[84] !== canManageXgSeats || $[85] !== canRemoveMemberFromProject || $[86] !== canResendInvitationToCompany || $[87] !== canViewCompanyMemberProfile || $[88] !== canViewMemberSeats || $[89] !== canViewProductDetails || $[90] !== canViewSubscriptionDetails || $[91] !== canViewTeams || $[92] !== hasUserPermissionCompanyLevel) {
    t24 = {
      canViewCompanyMemberProfile,
      canChangeDisplayName: false,
      canInviteUsersToCompany,
      canResendInvitationToCompany,
      canEditMember,
      canDeleteMemberFromCompany,
      canCreateGroups,
      canEditDefaultPlatform,
      canCreateNewTeam,
      canDeleteMembersFromTeam,
      canFetchTeams,
      canViewTeams,
      canEditTeams,
      canDeleteTeams,
      canInviteMembersToTeam,
      canRemoveMemberFromProject,
      canChangeMemberProjectRole,
      canViewSubscriptionDetails,
      canViewProductDetails,
      canExportWorkspace,
      canEditAllCompanyProjects,
      canManageSceneLicenses,
      canManageXgSeats,
      canViewMemberSeats,
      hasUserPermissionCompanyLevel
    };
    $[69] = canChangeMemberProjectRole;
    $[70] = canCreateGroups;
    $[71] = canCreateNewTeam;
    $[72] = canDeleteMemberFromCompany;
    $[73] = canDeleteMembersFromTeam;
    $[74] = canDeleteTeams;
    $[75] = canEditAllCompanyProjects;
    $[76] = canEditDefaultPlatform;
    $[77] = canEditMember;
    $[78] = canEditTeams;
    $[79] = canExportWorkspace;
    $[80] = canFetchTeams;
    $[81] = canInviteMembersToTeam;
    $[82] = canInviteUsersToCompany;
    $[83] = canManageSceneLicenses;
    $[84] = canManageXgSeats;
    $[85] = canRemoveMemberFromProject;
    $[86] = canResendInvitationToCompany;
    $[87] = canViewCompanyMemberProfile;
    $[88] = canViewMemberSeats;
    $[89] = canViewProductDetails;
    $[90] = canViewSubscriptionDetails;
    $[91] = canViewTeams;
    $[92] = hasUserPermissionCompanyLevel;
    $[93] = t24;
  } else {
    t24 = $[93];
  }
  return t24;
}